<template>
  
  <div class="delete delete-media">

    <h3 class="mt-0">
      Sei sicuro di voler eliminare questo file?
    </h3>

    <div class="actions">
      <button class="denied" @click="closeSection()">No, mantieni il fle</button>
      <button class="confirm" @click="deleteMedia()">Si, elimina il file</button>
    </div>

  </div>

</template>

<script>
export default {

  props: ['media'],

  methods: {

    deleteMedia: function(){

      this.$parent.deleteMedia();

    },

    closeSection: function(){

      this.$parent.delete_media = false;

    }

  }

}
</script>

<style scoped>
.delete{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255,255,255,.8);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.delete .actions{
  width: 100%;
  text-align: center;
}
button.denied{
  color: white;
  background-color: var(--blue-message);
  border: 1px solid var(--blue-message);
}
button.denied:hover{
  color: var(--blue-message);
  background-color: white;
}
button.confirm{
  color: white;
  background-color: var(--red);
  border: 1px solid var(--red);
}
button.confirm:hover{
  color: var(--red);
  background-color: white;
}
</style>